import BaseService from './BaseService'

interface ITemplateSetting {
  companyId: string
  templateLibraryAccessEnabled: boolean
}

export enum ShareWithType {
  ALL = 'ALL',
  AGENCY = 'AGENCY',
  REMOVE = 'REMOVE'
}

export interface ShareTemplateResponse {
  templateName?: string
  templateId?: string
  product?: string
  snapshotId: string
  dateAdded?: Date
  dateUpdated?: Date
  companyId?: string
  shareWith?: string
}

export interface importTemplateParams {
  templateId: string
  templateName: string
  companyId: string
}

export interface TemplateVisibilityResponse {
  isAccessible: boolean;
  isCompanyAccessEnabled: boolean;
  isLocationAccessEnabled: boolean;
}

class TemplateService extends BaseService {
  constructor(baseUrl: string) {
    super(baseUrl)
  }
  update = (body: ITemplateSetting) => this.requests.post(`/template-settings/update`, body)
  getByCompanyId = (companyId:string) => this.requests.get(`/template-settings/${companyId}`)
  getShareTemplateById = (shareId:string) : Promise<{data:{data:ShareTemplateResponse}}> =>
    this.requests.get(`/template-share-url/${shareId}`)
  getShareFunnelDetails = (templateId: string) : Promise<{ data:{data: { templateName: string;shareWith: string;}} }> =>
    this.requests.get(`/template-share-details/${templateId}`)
  importTemplate = (params: importTemplateParams, apiKey) =>
    this.requests.post('/import-template',params, { headers: { 'api-key': apiKey } })
  getTemplateVisibility = (companyId: string, locationId: string, product: string): Promise<{ data: TemplateVisibilityResponse }> =>
    this.requests.get(`/visibility/${companyId}/${locationId}/${product}`)
}

const instance = new TemplateService(BaseService.servicesConfig.Templates)

export default instance
